import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Typography } from '@mui/material';
import { CssTextField } from 'qubCommon/Inputs';

const DependentInvitationDialog = ({ open, setOpen, onClose, handleInviteDependent }) => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleInvite = async () => {
        try {
            setIsSubmitting(true);
            const res = await handleInviteDependent(email);
            if (res === 'success') setSuccess(true);
            setIsSubmitting(false);
        } catch (e) {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        onClose();
        setSuccess(false);
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle variant="h4">{success ? 'Success' : 'Invite a Dependent'}</DialogTitle>
            <DialogContent>
                {!success ? (
                    <CssTextField
                        fullWidth
                        label="Dependent Email"
                        placeholder="example@email.com"
                        variant="outlined"
                        margin="dense"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                event.preventDefault();
                                handleInvite();
                            }
                        }}
                    />
                ) : (
                    <div>
                        <Typography color="green" fontWeight="bold" align="center" mt={3}>
                            ✅ Mail has been sent successfully! <br />
                            In order for the member to proceed, an authorization code will be needed.
                            <br /> You can find the authorization code at the invited member's card!
                        </Typography>
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                {!success ? (
                    <Button disabled={isSubmitting} onClick={handleInvite} color="primary" variant="contained">
                        Invite
                    </Button>
                ) : null}
            </DialogActions>
        </Dialog>
    );
};

export default DependentInvitationDialog;
